<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        v-if="['ACCOUNT'].includes(this.values)"
        prop="reportDate"
        width="120"
        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"
        width="100"
        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="80"
        prop="spent"
        label="花费">
      </el-table-column>
      <el-table-column
        sortable
        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        prop="customPayCount"
        label="自定义付费数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdyff"
        label="自定义付费数成本">
      </el-table-column>
      <el-table-column
        prop="reactivation"
        label="自定义拉活数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdylh"
        label="自定义拉活数成本">
      </el-table-column>
      <el-table-column
        prop="customRetainCount"
        label="自定义次留">
      </el-table-column>
      <el-table-column
        prop="zdycl"
        label="自定义次留成本">
      </el-table-column>
      <el-table-column
        sortable
        prop="CVR"
        :formatter="ChangeToPercentage"
        label="转化率">
      </el-table-column>
      sortable
      <el-table-column
        prop="CLR"
        :formatter="ChangeToPercentage"
        label="次留率">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" v-if="flag" type="text" size="small">查看</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">定时</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {

      loading:false,
      isDisable:false,
      userUalue:'',
      options1: [{
        value: 'xiaoqing',
        label: '小晴',
        children: [{
          value: 'kdxf',
          label: '科大讯飞',
        },
          {
            value: 'zjwc1',
            label: '浙江挖财'
          },
          {
            value: 'jstb',
            label: '聚搜退保'
          }, {
            value: 'ybkq',
            label: '英博口腔'
          },

          {
            value: 'bjyc',
            label:'北京翊宸'
          },{
          value:'nbml',
            label: '宁波美莱'
          },
          {
            value:'ysgx',
            label: '思耀学堂'
          },{
            value:'mhjk',
            label: '美好健康'
          }

          ]
      }
      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
  //cb40eea503b274dadca8c71634393d407af24c9c0c2aa095c7c8665ec07f1d4e
      //e45ffb7db04197a72fe1
      //数据
      mhjk:['ea9ff6a734b2ccfb1092','b8e3328b8a512fa82043'],
      mhjktoken:['f0493e0796a9c2dd5254e4871827483c504a70f1084a89e0b014513aa61d4900','20367c19dc0b2512f3e303713d6a1d5dfe2e5443080b603daa300de36a7fd382'],
      sygx:['cd4b39242a3952693e50062e88d18c2c6178fa2fd6d488f3f7c1da5435a9e6af','ad2e64e16eb6d6cb785ae4ca6b429205acdbc5a5b305a73dfe815abeb766f83a','5821ba36f0f0a05e7dcb017dc478dd31e34de2401c8961218cebe7c8de321ea5'],
      sl:['f7b0285e54512a4e26b6c2ae9710fab2672090b7b588448ba2fff815a55b8a97'],
      fjzcyy:['ba286f3baabb2f556d8a','6b08249ccdb713fef8ae','8598b79b5ecd9150bf3d','fd6ebdf93648f8de6588','bdee43ff8b497ead22db'],
      ybkq:['04dcc1ac044f5466618e','7da06d3f391f388afe28','3a6bc91f0af2ec4bdcdf','f8f3e58799f9cb4a91f3','f0253ec8c6b33a8b6f07','1d4996fec21daddd41d5'],
      kdxf:['f7d14beb4ed2ca117c0f','c3cb7eebd1cfa5a06a3b','705c38abebf212d5def6'],
      kdxftoken:['3344716906b3167eda6d8d26988403b0b0cc376eb944a89b2c83760adcce426b','89c221ba6aae874e2aace860220c1ea94d03f757af3bce27691ad2062efecc15','240eccb54a4282c665af3a9866ae5d288b0af65cb9afc6ba3ab4b79f93ae55b1'],
      xiaoqing:['1b39ec617071e23de1c865ea772c1eace6392f195781a9128405a0d19920ea3d','e02e2618fc793dc152d82ce2ded524f97d775e108b295a1ce338117ca096fd5f',
        'b76f84d0eb68aea6faee58e82ad7cc652f7187eb23ef1b9d3d7f8eeb09cfba10','b95f6507ddfb81a25315f7efbd128bff442c3acc8bc485b2f096eea3aaab94e1','89fd201ce92c984ebc93d8bb1dc013c742824a8ffdcb514264ed6b17ce936764','08e14aa03641e9db67b9e0cd228d6439cbd5686ce8614457851412512b33c7f0'
          ,'7b30f0ddce7f01ddfaf6f6e97b2ee65f3f0cd790afc353f52d8a8d9d0457872d','2530ec7d33530dde21b2fc6ef7c9a6cb9747623e2666bac1d1b2d16f937279de','53f4378da10db6d19a925bd1257318f8b09969c20639ae46793713d4365045d7','141ef715fe7aae9ce2a6c20a6f4eb24c02c38f8761689390ec35e0129f4c1ae6','9a429197ad5b243057eb3a19a33e032b38c1bea1ee249d6e46e04f1a64d94ca1',
      '42e8d64b3628cacc321d34c8917be4ee529371b46f304fd57b9ba33258e02132','74e7717fec9d094c0ad2e730d7787e243cecc97923d8d732cb05157246b39590','7af96efac6438f46a85c3a06b356ed0e06f7a4657a32f9ce265ebf7afc4bb992'],
      ysgx:['8475e28ed1fcd6f6a17a','b17cd8c9270ebedcd392','dd91e0fd727e50967a0d'],
      xiaoqing1:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','bebae681e51f6c6d61181a1068bd861766755848946f1839d649ca4933378a86','e18203affbefa3ae8a544f4932ba0c816acdee42026cebaccad62af898f1480b'
      ,'b3178440072085e82a2d42896833deb929f0b4d7bc5f7b66bc8c35d5464e7352','420c0e1cf1e12daa627bfe1fa29cc011027cedb12f27e691ac1b998f58390e7b',
      '53f4378da10db6d19a925bd1257318f8b09969c20639ae46793713d4365045d7','141ef715fe7aae9ce2a6c20a6f4eb24c02c38f8761689390ec35e0129f4c1ae6','9a429197ad5b243057eb3a19a33e032b38c1bea1ee249d6e46e04f1a64d94ca1'

      ],
      nbml:['0d608a8173f4c4204aa6','e4761fe4ef3a7ab61fdd','51b284ddba2b283f6d68','1b941f5e5f11c87185f8','7e47b3e6217cbb7c972f','18ae1b047bd2a39acdca'],

      bjyctoken:['033de71309284098277ed4b8fd0960805ed8fb9e4fec0f9b5ee9360f89337cc7'],
      bjyc:['11c3079060deefc137a6','e6c7b47cb1469d7e9039','c70c2de851d03a8c5ee3','6bf8039b6abf9de40e80','38ff6996d83fd05ef2da','3f3741248fd73c9c72c2','e1d322b291df4c0dca63','7b30a8a6e6cfe275730e'],
      zjwc1:['a84d159a9cd6f2a605c4','ed8613d1bf8d958506bc',
        '87120a5bd5bf5aa59401','d072259f4d71223acd7d','79ae6653fec4d52adcd4',
        '6ca615644f81185d6e96','0c44704fdc2737a4d558','87dd7700626af2ad6d3d',
        'bfb7879db7d3a4093e77','90a03be22dbe2759a0aa',
        'f968210b86dab904086f','5ab661316f72070deaf0','19e6fa47dd929de27ad8',
        'b27d0972026739b261bf','0f9cbee492464e4e4a17','4ebb948ef42b3a87fc87','869848686a6f212b4724',,'c1b9a00ad201562b7fa8',
        '2f3661ee5b8694d88962','d30d15e9b9f6cae42db6','d8fa938659c2c3469fc8','27835810b269a2a52a8c','f7a036a8d223d75afe81','44dc46018f2d15e92013','8c1929ef18bd13d2ddd9','28411c4368e8e1f8d0f3','71e83a8b3ab5a0ed70e4','0d5e408822bf5c6f81f6','a315a1ed1a80d3333a37','673e48cf1b2f06cdaa8b','34e511b041e1259812f3','d140b8aa9baf4bcc2d8f'],
      jsgx:['208538fad40c9796ec00','08de207541e54d033eb7','66046cfed9f87891115e','f0760f6cfe8d319e3bef','a1254894a9a764c6816b','8625b7a0955d398442a4','2c7c047810425a0bef8d','6fcc09a59f009720e864','bb831f3700fd8e8127ed'],
      jstb:['d3dff35cc29c3563048e'],
      fjwctoken:['9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8'],
      fjwc:['b0ced990246896269f35','48ade4a1456272e488d8'],
      zuoen:['c2a16d4047d3d096b2700701fb5caba784e3c1031903fc8207b97b56909ab7a7'],
      marryu:['873a63615f6e42478a3b','1c96ea51e138b5a10655','01739c18a49cff216f35','d9dadce1a1edf45a862d','a99e101d860a977cb6dd','baa7f15045eed2cf32d5'],
      tangtang:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8','a823e200bc8f6a8edbbb56335c65ef65aa9bfa6e67f902ef073a28c97608ee71'],
      zjwc: ['d58d2e06d91f1fcc1734'],
      // fjwc:['9db7b3816397c12af284','a66e2afd3fd50539e5ec','9071fd2d5b9b757b9b2d','2626b6fcdf4d91dff0fc','091fe378ca7aa0bb5c94','103e87eb2d92bc66047b'],
      hy:['f6763ef4c7cca7225efb','d09cf958a84e5de25416','6f963ee7ef2204842267','50ac080cad4cff36ffc3','df7d6ac7df84f181a688','a25ab586a3553ff8eaf1','9deac08f2e3673ad300f','feaf67bcda0c309738ef','3d0b2634f608542d1192','4eaf5ef1fd96e08adae5','a792ffc806e9f33e292f','b2e529e765d0b0e5912e','906401571e91d8291402', '524b9ab96ac72038628f','2a5ce625e65e99284120','e3d11badf345bc4f0741',
        '0d98a87a735b5c65f336','17508515f18f416f5e59','c0603a5cb631ed0be6da','b8db99e2656e2a0ec32f','4357fefbc7f2e33ad75c','2881c6532d20213bde56', '830165add00acbf602b7','f328ba502923cf699f5d','73673fbd251d2b0124d9','2b68fce0d791a7fbc6da'],
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      money:200,
      value3:'',
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        flag:false,
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      TempData:[],
      table:false,
      dialog: false,
      dialog1:false,
      HourList:[],
      Hourmap:new Map,
      sums:0,
      flag:true,
      form:[],
      group:{},
      kaiguan:0,
      activeName: 'first',
      grouplist:{},
      dingshi:true,
      xiane:true,
      sks:''

    }
  },

  methods:{
    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },
    //总汇规则
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }
          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },

    //导出表单api
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },

    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },

    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance = this.temp1[key].balance / 100000
        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }

        this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
        this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
        this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);



        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.temp3[key].dailyBudget!=-1){
          t=this.temp3[key].dailyBudget/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }

      this.loading=false
    },


    //查询广告效果api
    async PostListQuery(parms){

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
          if (resp.data.code!==60806){
        if (resp.data.data.items !=null){
          if (this.value==="HOUR"){
            // 存取小时的数据[]
            this.sums=this.sums+1;
            console.log(resp.data.data.items)
            this.Hourmap.set(this.sums,resp.data.data.items)

            // console.log(this.Hourmap.get(parms.a))
            let arr=[];
            let map=new Map;
            for(let key in resp.data.data.items){
              var time=new Date(resp.data.data.items[key].reportTime)
              let reTimeHour=time.getHours(); //获取返回整点时间
              var date=new Date()
              let hour=date.getHours();  // 获取当前时间
              if (hour===reTimeHour){
                arr.push(key)   //定位现在整时位置
                map.set(key,resp.data.data.items[key])// 记录下现在的数据
              }
            }
            for (let keys in arr){

              this.datadata.push(map.get(arr[keys]))
              let obj={
                ids:resp.data.data.items[arr[keys]].campaignId,
                lengths:arr.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:arr.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }else{
            console.log(resp.data.data.items)
            for (let b=0;b<resp.data.data.items.length;b++){
              this.datadata.push(resp.data.data.items[b])
              let obj={
                ids:resp.data.data.items[b].campaignId,
                lengths:resp.data.data.items.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:resp.data.data.items.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }

        }
      }})

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.getDataList()
        }

      })


    },
    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },
    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },
    getDataList() {
      this.loading=true
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      if(this.userUalue[0]==="tangtang"){
        this.isDisable = true
        this.TimeChange();
      }else if(this.userUalue[0]=="zuoen"){
        this.isDisable = true
        this.TimeChangetozuoen();
      }else if(this.userUalue[0]="xiaoqing"){
        this.isDisable = true
        this.TimeChangetoxiaoqing();
      }
    },
    async TimeChange () {
      if (this.userUalue[1]==="fjwc"){
        console.log(this.value)
        for (let a = 0; a < this.fjwc.length; a++) {

          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.tangtang[1] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.fjwc[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            console.log(resp.data.data)

            if (resp.data.data.items != null) {
              // 追加数据
              console.log(resp.data.message)

              this.$message.success("正在查询第"+a+"条数据")
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.tangtang[1] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.fjwc[a])
                .then(res => {
                  console.log(res.data.message)
                  if (res.data.message == '请求成功') {
                    this.namedata.push(res.data.data)
                  } else {
                    console.log(res.data.message)
                  }
                })
            }
          })
        }
        //渲染页面
        setTimeout(()=>{
          this.temp=JSON.parse(JSON.stringify(this.datadata))
          this.temp1=JSON.parse(JSON.stringify(this.namedata))
          for (let key=0;key<this.temp.length;key++){
            this.temp1[key].balance=this.temp1[key].balance/100000
            this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
            this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR=this.temp2[key].formsubmitCount/this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);


            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);


            this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          }
          setTimeout(()=>{},1000)

          this.datas=this.temp2
          this.isDisable = false
        },3000)

      } else if(this.userUalue[1]=="hy"){

        for (let a = 0; a < this.hy.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.tangtang[2] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.hy[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {

            if (resp.data.data.items != null) {
              // 追加数据

              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }

              this.$message.success("正在查询第" + a + "条数据")
              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.tangtang[2] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.hy[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)
                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            //自定义次留成本

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);



            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])




          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)
      }


      else if(this.userUalue[1]="zjwc"){

        for (let a = 0; a < this.zjwc.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.tangtang[0] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.zjwc[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第"+a+"条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.tangtang[0] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.zjwc[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页面
        setTimeout(()=>{
          this.temp=JSON.parse(JSON.stringify(this.datadata))
          this.temp1=JSON.parse(JSON.stringify(this.namedata))
          for (let key=0;key<this.temp.length;key++){
            this.temp1[key].balance=this.temp1[key].balance/100000
            this.temp2[key]=this.hb(this.temp1[key],this.temp[key])


            this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR=this.temp2[key].formsubmitCount/this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])

          }

          this.datas=this.temp2
          this.isDisable = false
        },4000)

      }

    },
    async TimeChangetozuoen () {
      if (this.userUalue[1]==="marryu"){

        for (let a = 0; a < this.marryu.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.zuoen[0] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.marryu[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.zuoen[0] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.marryu[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)


      }


    },
    async TimeChangetoxiaoqing () {
      if (this.userUalue[1]==="ysgx"){
        for (let a = 0; a < this.ysgx.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.sygx[a] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.ysgx[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.sygx[a] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.ysgx[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面


          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].nameid=this.temp1[key].name


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }


          this.datas = this.temp2
          this.isDisable = false
          this.loading=false



      }
      if (this.userUalue[1]==="mhjk"){
        for (let a = 0; a < this.mhjk.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.mhjktoken[a] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.mhjk[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.mhjktoken[a] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.mhjk[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面


        this.temp = JSON.parse(JSON.stringify(this.datadata))
        this.temp1 = JSON.parse(JSON.stringify(this.namedata))
        for (let key = 0; key < this.temp.length; key++) {
          this.temp1[key].balance = this.temp1[key].balance / 100000
          this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
          this.ctrJson[0].nameid=this.temp1[key].name


          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

          this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
          // 截取当前数据到小数点后两位 （四舍五入）
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          // 先截取当前数据到小数点后三位 （不会四舍五入）
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          // 再取该数值长度-1的内容
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

          // 截取当前数据到小数点后两位 （四舍五入）
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          // 先截取当前数据到小数点后三位 （不会四舍五入）
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          // 再取该数值长度-1的内容
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

          this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

          // 截取当前数据到小数点后两位 （四舍五入）
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          // 先截取当前数据到小数点后三位 （不会四舍五入）
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          // 再取该数值长度-1的内容
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

        }


        this.datas = this.temp2
        this.isDisable = false
        this.loading=false



      }
      if (this.userUalue[1]==="zjwc1"){
        this.sks=this.xiaoqing1[0]
        this.sums=0;
        for (let a = 0; a < this.zjwc1.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zjwc1
          }
          await this.PostListQuery(parms)
        }
        this.sums=0;
        for (let a = 0; a < this.fjwc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.fjwctoken,
            adid:this.fjwc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      if (this.userUalue[1]==="jsgx"){
        this.sks=this.xiaoqing1[1]
        this.sums=0;
        for (let a = 0; a < this.jsgx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jsgx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      if (this.userUalue[1]==="jstb"){
        this.sks=this.xiaoqing1[2]
        this.sums=0;
        for (let a = 0; a < this.jstb.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jstb
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="bjyc"){
        this.sks=this.bjyctoken[0]
        this.sums=0;
        for (let a = 0; a < this.bjyc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bjyc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="nbml"){
        this.sks=this.sl[0]
        this.sums=0;
        for (let a = 0; a < this.nbml.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.nbml
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }

      if (this.userUalue[1]==="fjzcyy"){
        this.sks=this.xiaoqing1[3]
        for (let a = 0; a < this.fjzcyy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.fjzcyy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      if (this.userUalue[1]==="ybkq"){
        this.sks=this.xiaoqing1[4]
        for (let a = 0; a < this.ybkq.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ybkq
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      if (this.userUalue[1]==="kdxf"){

        for (let a = 0; a < this.kdxf.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.kdxftoken[a] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.kdxf[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.kdxftoken[a] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.kdxf[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面



          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].nameid=this.temp1[key].name


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }

          this.datas = this.temp2
          this.isDisable = false
        this.loading=false



      }
    },
  },
  created () {  },
}
</script>



// WEBPACK FOOTER //
// src/components/xiaoqing.vue